import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TuiButton, TuiLoader, TuiNotification } from '@taiga-ui/core';
import { EmptyBlockComponent } from '@core/components';
import type {
  WorkflowPendingWorkSummary,
  WorkflowScreenState,
} from '@core/services/workflow';

/**
 * Отдельный UI для каждого состояния экрана регламентов: загрузка, нет доступа,
 * не найдено, недоступно офлайн, офлайн-снимок, неотправленные и неотправившиеся изменения
 */
@Component({
  selector: 'x-workflow-screen-state',
  imports: [
    TranslatePipe,
    TuiButton,
    TuiLoader,
    TuiNotification,
    EmptyBlockComponent,
  ],
  templateUrl: './workflow-screen-state.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowScreenStateComponent {
  readonly state = input.required<WorkflowScreenState>();
  readonly pendingWork = input.required<WorkflowPendingWorkSummary>();
  /** Показывать ли блокирующие состояния (на странице формы — только баннеры) */
  readonly showBlockingStates = input(true);

  readonly retry = output<void>();
}
